import MobileSearchOverlayBody from "./mobile-search-overlay-body";
import { MOBILE_SEARCH_OVERLAY_EVENT_HANDLERS } from "./mobile-search-overlay-events";
import MobileSearchOverlayHeader from "./mobile-search-overlay-header";
import { normalizeTerm } from "./search-utils";

const MobileSearchOverlay = ({
  inputRef,
  searchState,
  suggestionState,
  searchActions,
  mobileOverlayVariant = "default",
}) => {
  const { search, setSearch } = searchState;
  const { closeSearch, routeToSearch } = searchActions;
  const isPlayOverlay = mobileOverlayVariant === "play";
  const isMainOverlay =
    mobileOverlayVariant === "main" || mobileOverlayVariant === "default";
  const hasEmbeddedSearchActions = isPlayOverlay || isMainOverlay;
  const trimmedSearch = normalizeTerm(search);
  const hasTypedSearch = trimmedSearch.length > 0;

  return (
    <div
      className="fixed inset-0 z-[140] bg-[#fbfbfc] text-black md:hidden dark:bg-custom_black dark:text-white"
      id="mobile-search-overlay"
      {...MOBILE_SEARCH_OVERLAY_EVENT_HANDLERS}
    >
      <MobileSearchOverlayHeader
        search={search}
        setSearch={setSearch}
        inputRef={inputRef}
        onClose={closeSearch}
        onSubmit={routeToSearch}
        trimmedSearch={trimmedSearch}
        isPlayOverlay={isPlayOverlay}
        isMainOverlay={isMainOverlay}
        hasEmbeddedSearchActions={hasEmbeddedSearchActions}
      />

      <MobileSearchOverlayBody
        trimmedSearch={trimmedSearch}
        hasTypedSearch={hasTypedSearch}
        suggestionState={suggestionState}
        searchActions={searchActions}
      />
    </div>
  );
};

export default MobileSearchOverlay;
